if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer = document.querySelector('cart-drawer');
      this.form = this.querySelector(
        `form#${this.getAttribute('data-form-id')}`,
      );
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.form?.querySelector('[type="submit"]');
      this.mediaWrapper = this.querySelector('[data-media-wrapper]');
      this.variants = JSON.parse(
        this.querySelector('[type="application/json"][data-variants]')
          .textContent,
      );
      this.variantsImages = JSON.parse(
        this.querySelector('[type="application/json"][data-variants-images]')
          .textContent,
      );
      this.swatches = this.querySelectorAll('[data-swatch]');
      this.swatches.forEach((swatch) => {
        swatch.addEventListener('change', this.onSwatchChange.bind(this));
      });
      this.activeVariant = this.variants?.find(
        (variant) => variant.id === Number(this.dataset.activeVariantId),
      );
      this.formSubmitTrigger = this.querySelector('.js-product-card-form-trigger');
      if (this.formSubmitTrigger) {
        this.formSubmitTrigger.addEventListener('click', this.triggerFormSubmit.bind(this));
      }
    }

    onSubmitHandler(event) {
      event.preventDefault();

      this.submitButton.classList.add('disabled');

      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer.getSectionsToRender().map((section) => section.section),
      );
      formData.append('sections_url', window.location.pathname);

      Cart.add(formData)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      window.dispatchEvent(
        new CustomEvent('formError', { detail: errorMessage }),
      );

      if (typeof errorMessage == 'string') {
        alert(errorMessage);
      }
    }

    onSwatchChange(event) {
      const activeVariant = this.variants.find(
        (variant) =>
          variant[`option${this.dataset.swatchOptionIndex}`] ===
          event.target.value,
      );
      this.activeVariant = activeVariant;
      this.updateAssets(activeVariant);
    }

    updateAssets(activeVariant) {
      this.updateMedia(activeVariant);
      this.updateVariantInput(activeVariant);
      this.updateLinks(activeVariant);
    }

    updateMedia(activeVariant) {
      const media = this.querySelector('[data-media-wrapper]');
      const primaryImage = this.querySelector('[data-image-primary]');
      const variantImage = this.variantsImages.find(
        (variant) => variant.id === activeVariant.id,
      );

      if (!primaryImage || !variantImage) return;

      media.classList.add('is-loading');
      primaryImage.addEventListener(
        'transitionend',
        () => {
          primaryImage.src = variantImage.image.src;
          primaryImage.srcset = variantImage.image.srcset;
          primaryImage.onload = () => {
            media.classList.add('is-changed');
            media.classList.remove('is-loading');
          };
        },
        { once: true },
      );
    }

    updateVariantInput(activeVariant) {
      const input = this.querySelector('[name="id"]');
      input.value = activeVariant.id;
    }

    updateLinks(activeVariant) {
      const links = this.querySelectorAll('[data-url]');

      links.forEach((link) => {
        link.setAttribute(
          link.hasAttribute('href') ? 'href' : 'data-url',
          `${this.dataset.productUrl}?variant=${activeVariant.id}`,
        );
      });
    }

    triggerFormSubmit(e) {
      if (e) e.preventDefault();
      if (this.submitButton) this.submitButton.click();
    }
  }

  customElements.define('card-product', CardProduct);
}
